import { render, staticRenderFns } from "./KasTarKochPechat.vue?vue&type=template&id=53228ebc"
import script from "./KasTarKochPechat.vue?vue&type=script&lang=js"
export * from "./KasTarKochPechat.vue?vue&type=script&lang=js"
import style0 from "./KasTarKochPechat.vue?vue&type=style&index=0&id=53228ebc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports